import * as Website from '../../Config/Website.js';
import * as UpdateStatus from '../../Modules/UpdateStatus.js';
import mapSlider from '../../Modules/mapSlider.js';
import scrollHint from '../../Modules/ScrollHint.js';



const preinit = () => {

}

const init = () => {
  mapSlider();
  scrollHint();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {
  UpdateStatus.scroll();
}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}
